import type { ErrorResponse, FilterInfo } from '@/types/common';
import type {
	AttendeeMessageInfo,
	AttendeeCheckInInfo,
	AttendeeCheckInResponse,
	AttendeeMessageResponse,
	AttendeeOrderData,
	AttendeeReportResponse,
	CancelItem,
	OrderResponse,
	AttendeeDataResponse,
} from '@/types/attendee';

export const getAttendeeOrderByEventId = (eventId: number, filterInfo?: FilterInfo) => {
	return useRequest<AttendeeOrderData, ErrorResponse>(
		`${EVENT_ENDPOINT}/${eventId}${ORDER_ENDPOINT}`,
		REQUEST_METHOD.GET,
		{},
		{
			filter: filterInfo?.search,
			sortBy: filterInfo?.sortBy,
			status: filterInfo?.status,
			currentPage: filterInfo?.currentPage,
			itemPerPage: filterInfo?.itemPerPage,
		},
	);
};

export const putAttendeeCheckIn = (eventId: number, checkInInfo: AttendeeCheckInInfo) => {
	return useRequest<{ data: AttendeeCheckInResponse }>(
		`${CHECK_IN_ENDPOINT}/event/${eventId}${ATTENDEE_ENDPOINT}`,
		REQUEST_METHOD.PUT,
		{
			aid: checkInInfo.attendeeId,
			status: checkInInfo.status,
		},
	);
};

export const putAttendeeQrCodeCheckIn = (eventId: number, hash: string) => {
	return useRequest<{ data: AttendeeCheckInResponse }>(
		`${CHECK_IN_ENDPOINT}/event/${eventId}${ATTENDEE_ENDPOINT}`,
		REQUEST_METHOD.PUT,
		{
			hash,
		},
	);
};

export const postAttendeeMessageToAll = (eventId: number, messageInfo: AttendeeMessageInfo) => {
	return useRequest<{ data: AttendeeMessageResponse }>(
		`${MESSAGE_ENDPOINT}/event/${eventId}`,
		REQUEST_METHOD.POST,
		{
			type: messageInfo.type,
			subject: messageInfo?.subject,
			body: messageInfo.body,
		},
	);
};

export const postAttendeeMessageToIndividual = (
	eventId: number,
	messageInfo: AttendeeMessageInfo,
) => {
	return useRequest<{}, ErrorResponse>(
		`${EVENT_ENDPOINT}/${eventId}/messaging${ATTENDEE_ENDPOINT}`,
		REQUEST_METHOD.POST,
		{
			toAttendanceIds: messageInfo.ids,
			subject: messageInfo?.subject,
			body: messageInfo.body,
		},
	);
};

export const postAttendeeCancel = (
	eventId: number,
	saleId: number,
	cancelledItems: CancelItem[],
) => {
	return useRequest<{}, ErrorResponse>(
		`${EVENT_ENDPOINT}/${eventId}${ORDER_ENDPOINT}/${saleId}/cancel`,
		REQUEST_METHOD.POST,
		{
			items: cancelledItems,
		},
	);
};

export const getAttendeeDownloadByEventId = (eventId: number) => {
	return useRequest<AttendeeReportResponse, ErrorResponse>(
		`${EVENT_ENDPOINT}/${eventId}/attendances/download`,
		REQUEST_METHOD.GET,
	);
};

export const getOrderBySalesId = (eventId: number, salesId: number) => {
	return useRequest<OrderResponse, ErrorResponse>(
		`${EVENT_ENDPOINT}/${eventId}${ORDER_ENDPOINT}/${salesId}`,
		REQUEST_METHOD.GET,
	);
};

export const getAttendeesByEventId = (eventId: number, currentPage: number, limit?: number) => {
	return useRequest<AttendeeDataResponse, ErrorResponse>(
		`${EVENT_ENDPOINT}/${eventId}${ATTENDEE_ENDPOINT}`,
		REQUEST_METHOD.GET,
		{},
		{
			currentPage,
			limit,
		},
	);
};